<template>
    <div class="container-fluid bg-grey">
        <div class="row">
            <div class="container m-y-xl">
                <div class="title text-center">
                    <h1 class="text-cgrey ">Retrieve password</h1>
                </div>
                <h4 class="text-cgrey text-center">
                    Enter your new password twice below to reset your password. You will NOT be able to use your old password.
                </h4>
                <div class="text-center bg-white fine-border border-green m-t p-t-md p-b-lg">
                    <div class="w-md m-auto">
                        <div class="form m-y">
                            <template v-if="!successMessage">
                                <div class="form-group field">
                                    <input v-model="password"
                                        placeholder="Password"
                                        ref="reset-password"
                                        @keyup.enter="validateForm"
                                        type="password"
                                        name="reset-password"
                                        data-vv-validate-on="change"
                                        data-vv-as="password"
                                        v-validate="{ required: true, regex: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,}/ }"
                                        class="form-control input-group js-input-password">

                                    <span v-show="errors.has('reset-password')" class="vv-error-message">{{ errors.first('reset-password') }}</span>
                                </div>

                                <div class="form-group field">
                                        <input v-model="confirmPassword"
                                            placeholder="Confirm Password"
                                            type="password"
                                            @keyup.enter="validateForm"
                                            name="confirm-reset-password"
                                            data-vv-as="confirm password"
                                            data-vv-validate-on="change"
                                            v-validate="'required|confirmed:reset-password'"
                                            class="form-control input-group js-input-password">

                                        <span v-show="errors.has('confirm-reset-password')" class="vv-error-message">
                                            {{ errors.first('confirm-reset-password') }}
                                        </span>
                                </div>
                                <button
                                    @click="validateForm"
                                    class="btn btn-round btn-block btn-green"
                                    :class="{'disable-element': isSendingEmail }"
                                    :disabled="isSendingEmail"
                                    type="submit">
                                    {{ isSendingEmail ? "SUBMITING..." : "SUBMIT" }}
                                </button>
                            </template>
                            <h4 v-else class="text-cgrey text-center">
                                {{ successMessage }}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Validator } from 'vee-validate';

export default {
    data() {
        return {
            successMessage: '',
            isSendingEmail: false,
            password: "",
            confirmPassword: ""
        }
    },
    created() {
        this.setupValidationErrorMessages();
    },
    methods: {
        async validateForm() {
            const isValid = await this.$validator.validateAll();
            if (!isValid) {
                return;
            }

            this.submitForm();
        },
        submitForm() {
            this.isSendingEmail = true;

            const formData = new FormData();
            formData.append("password", this.password);

            axios.post(`/auth/reset/${this.$route.params.token}`, formData).then(response => {
                this.successMessage = response.data.message;
            }).catch(error => {
                toastr.error(error.response.data.status.message);
            }).finally(() => this.isSendingEmail = false);
        },
        setupValidationErrorMessages() {
            const dictionary = {
                en: {
                    custom: {
                        "reset-password": {
                            regex: () => {
                                if (!this.password) {
                                    return "Please enter in a password."
                                } else if (!this.password.match(/^.{6,}$/g)) {
                                    return "Please enter in a password 6 characters or longer for your own security."
                                } else if (!this.password.match(/\d/g)) {
                                    return  "Password must include a number."
                                } else if (!this.password.match(/(?=.*[a-z])/g)) {
                                    return "Password must include an lowercase letter."
                                } else if (!this.password.match(/(?=.*[A-Z])/g)) {
                                    return "Password must include an uppercase letter."
                                }
                            }
                        },
                        "confirm-reset-password": {
                            required: 'You must confirm your password!',
                            confirmed: 'Your passwords does not match, please try again.'
                        }
                    }
                }
            };

            Validator.localize(dictionary);
        }
    }
}
</script>

<style scoped>
    .btn:focus {
        color: white;
    }
    .btn:hover {
        color: var(--purple);
    }
    .vv-error-message {
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        color: red;
    }
</style>